export default __webpack_public_path__ + "0fabfcfce9a1a78a5723ab0268fb22e4.gif";